<template>
  <div
    v-if="$slots.default"
    class="d-card"
    :class="{'is-disabled': disabled, 'is-clipped': clipped, 'is-compact': compact}"
  >
    <slot />

    <div
      v-if="disabled"
      class="d-card-overlay"
    />
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      default: false,
      type: Boolean
    },
    clipped: {
      default: false,
      type: Boolean
    },
    compact: {
      default: false,
      type: Boolean
    }
  }
};
</script>
